import { ManageInviteesPage } from "./ManageInviteesPage";

export default ManageInviteesPage;
